/**
 * A field config's own `dropdownOptions` as the `{ id, label }` list the drawer's dropdowns take,
 * read off `_id` as every other config-driven option branch in InputRenderer already reads it.
 *
 * Config is server data, so an entry the dropdown could not render is dropped rather than handed
 * over — a label it would call `toLowerCase` on while searching has to be a string.
 */
export const toConfigDropdownOptions = (config: any): { id: string; label: string }[] =>
    (Array.isArray(config?.dropdownOptions) ? config.dropdownOptions : [])
        .filter((opt: any) => !!opt?._id && typeof opt?.label === 'string' && opt.label !== '')
        .map((opt: any) => ({ id: opt._id, label: opt.label }));
